import { HznLoading } from './loading/loading.js';
import { defineHorizonElement } from '@horizon/common/helpers';
import '@horizon/style/fonts/inject.js';
import './types.js';
defineHorizonElement('hzn-loading', HznLoading);
